import React from "react";
import MenuItem from "./MenuItem";
import { MenuItem as MenuItemType } from "../MenuData";

interface MenuSectionProps {
    title: string;
    items: MenuItemType[];
    expandedSections: { [key: string]: boolean };
    setExpandedSections: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
    activeItem: string;
    setActiveItem: React.Dispatch<React.SetStateAction<string>>;
    onItemClick?: (item: MenuItemType) => void;
    isExpanded?: boolean;
}

const MenuSection: React.FC<MenuSectionProps> = ({
    title,
    items,
    expandedSections,
    setExpandedSections,
    activeItem,
    setActiveItem,
    onItemClick,
    isExpanded = true,
}) => {
    return (
        <div>
            {!!title && isExpanded && (
                <h2 className="px-3 mb-2 text-gray-500 font-semibold">{title}</h2>
            )}
            <ul className="space-y-2">
                {items.map((item) => (
                    <MenuItem
                        key={item.id ?? item.label}
                        item={item}
                        expandedSections={expandedSections}
                        setExpandedSections={setExpandedSections}
                        activeItem={activeItem}
                        setActiveItem={setActiveItem}
                        onClick={(item) => onItemClick ? onItemClick(item) : null}
                        isExpanded={isExpanded}
                    />
                ))}
            </ul>
        </div>
    );
};

export default MenuSection;
